import { store } from "../app/store";
import { logout } from "./auth/authSlice";
import { getCookie, TOKEN_COOKIE } from "../utils/cookies";

const isTokenExpired = (token: string): boolean => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const useToken = (): string => {
  const token = getCookie(TOKEN_COOKIE);
  if (!token) {
    throw new Error("Authentication token not found.");
  }
  if (isTokenExpired(token)) {
    store.dispatch(logout());
    throw new Error("Authentication token has expired.");
  }
  return token;
};
